<template>
    <v-form ref="petDemographicForm" v-model="currentPetDemographic.isValid">
        <!--<img v-if="archimedes" src="@/assets/cat.gif" id="archimedes" />-->
        <v-container class="py-0 py-sm-0">
            <v-row>
                <v-col class="pl-10 py-0 py-sm-0" style="min-height: 445px; overflow-y: hidden!important; ">
                    <div class="form-group mb-6" v-if="currentModel.settings.walkInShowPetName">
                        <label for="Pet name">{{ currentModel.settings.localizedContent['reservation_pet_name_label'] }}</label>
                        <v-text-field v-model="currentPetDemographic.formData.petName"
                                      name="PetName"
                                      background-color="white"
                                      id="petName"
                                      ref="petName"
                                      class="mt-1"
                                      autocomplete="off"
                                      :rules="petNameRules"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="petNameValid" color="secondary">mdi-check</v-icon>
                        <!--v-bind:class="{'archimedes': archimedes}">-->
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetSpeciesGeneral">
                        <label for="species">{{ currentModel.settings.localizedContent['reservation_pet_species_general_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.species"
                                  :items="speciesList"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="species"
                                  id="species"
                                  ref="species"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.species" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetSubSpecies">
                        <label for="subSpecies">{{ currentModel.settings.localizedContent['reservation_pet_subspecies_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.subSpecies"
                                  :items="petSubSpecies"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="subSpecies"
                                  id="subSpecies"
                                  ref="subSpecies"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.subSpecies" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetBreed">
                        <div>
                            <label for="petBreed">{{ currentModel.settings.localizedContent['reservation_pet_breed_label'] }}</label>
                        </div>
                        <v-text-field v-model="currentPetDemographic.formData.petBreed"
                                      name="petBreed"
                                      background-color="white"
                                      id="petBreed"
                                      ref="petBreed"
                                      class="mt-1"
                                      autocomplete="off"
                                      :rules="petBreedRules"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="petBreedValid" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetColor">
                        <label for="petColor">{{ currentModel.settings.localizedContent['reservation_pet_color_label'] }}</label>
                        <v-text-field v-model="currentPetDemographic.formData.petColor"
                                      name="PetColor"
                                      background-color="white"
                                      id="petColor"
                                      ref="petColor"
                                      class="mt-1"
                                      autocomplete="off"
                                      :rules="petColorRules"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="petColorValid" color="secondary">mdi-check</v-icon>
                        <!--v-bind:class="{'archimedes': archimedes}">-->
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'CALENDER_DATE'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-text-field v-facade="'##/##/####'"
                                      v-model="currentPetDemographic.formData.petApproxAge"
                                      name="PetApproxAge"
                                      type="text"
                                      class="mt-1"
                                      id="petApproxAge"
                                      ref="petApproxAge"
                                      background-color="white"
                                      autocomplete="off"
                                      :rules="petApproxCalenderAgeAgeRules"
                                      placeholder="MM/DD/YYYY"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="approxAgeValid" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'PICKLIST'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.petApproxAge"
                                  :items="currentModel.settings.approximateAgeValues"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="approxAge"
                                  id="petApproxAge"
                                  ref="petApproxAge"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="approxAgeValid" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'FREE_TEXT'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="currentPetDemographic.formData.petApproxAge"
                                              name="petApproxAge"
                                              background-color="white"
                                              id="petApproxAge"
                                              ref="petApproxAge"
                                              class="mt-1"
                                              autocomplete="off"
                                              :rules="petApproxAgeRules"
                                              solo
                                              outlined
                                              validate-on-blur>
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-select v-model="currentPetDemographic.formData.petApproxAgeType"
                                          :items="currentModel.settings.approximateAgeTypes"
                                          :allow-overflow="false"
                                          class="mt-1"
                                          name="petApproxAgeType"
                                          id="petApproxAgeType"
                                          ref="petApproxAgeType"
                                          background-color="white"
                                          outlined>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-icon class="input-valid" v-if="approxAgeValid" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mt-6" v-if="currentModel.settings.petGenders.length === 2 && currentModel.settings.showWalkInPetGender">
                        <label style="display: block;">{{ currentModel.settings.localizedContent['reservation_pet_gender_label'] }}</label>
                        <v-btn-toggle v-model="currentPetDemographic.formData.sex" class="has-2-toggles" :dense="$vuetify.breakpoint.xs">
                            <v-btn value="Male" large outlined color="primary" light>Male</v-btn>
                            <v-btn value="Female" large outlined color="primary" light>Female</v-btn>
                        </v-btn-toggle>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.sex" color="secondary" style="top: -40px; left: -37px;">mdi-check</v-icon>
                    </div>
                    <div class="form-group mt-6" v-if="currentModel.settings.petGenders.length !== 2 && currentModel.settings.showWalkInPetGender">
                        <label style="display: block;">{{ currentModel.settings.localizedContent['reservation_pet_gender_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.sex"
                                  :items="currentModel.settings.petGenders.map(x => x.petGenderName)"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="PetGender"
                                  id="petGender"
                                  ref="petGender"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.sex" color="secondary" style="top: -70px; left: -37px;">mdi-check</v-icon>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import moment from 'moment';
    import ContextualMixin from '../mixins/contextualMixin'

    export default {
        name: 'Demographic',
        mixins: [ContextualMixin],
        data() {
            return {
                petNameRules: [
                    v => !!v || 'Pet name is required',
                    v => /^[a-zA-Z0-9 '-.´]+$/.test(v) || 'Pet name is invalid.',
                    v => isNaN(v) || 'Pet name is invalid'
                ],
                petColorRules: [
                    v => !!v || 'Pet color is required'
                ],
                petApproxAgeRules: [
                    v => !isNaN(v) || 'Age should be numeric'
                ],
                petApproxFreeTextAgeRules: [
                    v => !!v || 'Date of birth is required',
                    v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', false) < 120 || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', true) > 0 || 'Date of birth is invalid',
                    v => moment(v, 'MM/DD/YYYY', true).years() > 1000 || 'Date of birth is invalid',
                ],
                petApproxCalenderAgeAgeRules: [
                    v => !!v || 'Date of birth is required',
                    v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', false) < 120 || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', true) > 0 || 'Date of birth is invalid',
                    v => moment(v, 'MM/DD/YYYY', true).years() > 1000 || 'Date of birth is invalid',
                ],
                petBreedRules: [
                    v => !!v || 'Pet Breed is required',
                    v => /^[a-zA-Z0-9 '-.´]+$/.test(v) || 'Pet Breed is invalid.',
                    v => isNaN(v) || 'Pet Breed is invalid'
                ]
            }
        },
        computed: {
            speciesList() {
                if (!this.$store.state.currentModel.settings.species) return [];
                return this.$store.state.currentModel.settings.species.map(x => x.speciesName);
            },
            petSubSpecies() {
                if (!this.$store.state.currentPetDemographic.formData.species) return [];

                let tis = this;
                let speciesId = this.$store.state.currentModel.settings.species.filter(x => x.speciesName === tis.$store.state.currentPetDemographic.formData.species)[0].id;
                return this.$store.state.currentModel.settings.subSpecies.filter(x => x.speciesId === speciesId)
                    .map(x => x.subSpeciesName);
            },
            currentPetDemographic() {
                return this.$store.state.currentPetDemographic;
            },
            currentPetDemographicRef() {
                return this.$refs.petDmographicForm;
            },
            petNameValid() {
                if (!this.currentPetDemographic.formData.petName || !this.$refs.petName)
                    return false;
                return this.$refs.petName.validate();
            },
            petBreedValid() {
                if (!this.currentPetDemographic.formData.petBreed || !this.$refs.petBreed)
                    return false;
                return this.$refs.petBreed.validate();
            },
            petColorValid() {
                if (!this.currentPetDemographic.formData.petColor || !this.$refs.petColor)
                    return false;
                return this.$refs.petColor.validate();
            },
            approxAgeValid() {
                if (!this.currentPetDemographic.formData.petApproxAge || !this.$refs.petApproxAge)
                    return false;
                console.log(this.currentPetDemographic.formData.petApproxAge);
                return this.$refs.petApproxAge.validate();
            },
            approxAgeCalenderDateValid() {
                if (!this.currentPetDemographic.formData.petApproxAge || !this.$refs.petApproxAge)
                    return false;
                console.log('value logged');
                console.log(this.currentPetDemographic.formData.petApproxAge);
                return true;
            }
            //dobValid() {
            //    if (!this.currentDemographic.formData.dob || !this.$refs.dob)
            //        return false;
            //    return this.$refs.dob.validate();
            //},
            //archimedes() {
            //    return this.currentDemographic.formData.firstName
            //        && this.currentDemographic.formData.firstName.toLowerCase().includes('archimedes');
            //}
        },
        watch: {
            'currentPetDemographic.formData.petName': function (v) {
                if (!v || !v.length)
                    return;
                let fn = this.$store.state.currentPetDemographic.formData.petName;
                if (v.charAt(0) !== v.charAt(0).toUpperCase())
                    this.$store.state.currentPetDemographic.formData.petName =
                        fn.charAt(0).toUpperCase() + fn.slice(1);
            }
        }
    }
</script>
<style>
    #archimedes {
        position: fixed;
        bottom: 15px;
        left: -50%;
        z-index: 1;
        animation: run 4s infinite normal linear;
    }

    @-webkit-keyframes run {
        0% {
            left: -50%;
        }

        100% {
            left: 100%;
        }
    }

    @keyframes run {
        0% {
            left: -50%;
        }

        100% {
            left: 100%;
        }
    }
</style>